import "core-js/modules/es6.array.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import { SyncMapper, GenericElementMapper, ItemMapper, LanguageMapper, TaxonomyMapper, TypeMapper } from '../mappers';
export var MappingService =
/*#__PURE__*/
function () {
  function MappingService(config) {
    _classCallCheck(this, MappingService);

    this.config = config;
    this.typeMapper = new TypeMapper();
    this.languageMapper = new LanguageMapper();
    this.itemMapper = new ItemMapper(config);
    this.taxonomyMapper = new TaxonomyMapper();
    this.genericElementMapper = new GenericElementMapper();
    this.syncMapper = new SyncMapper();
  }
  /**
   * Gets response for list of languages
   * @param data Response data
   */


  _createClass(MappingService, [{
    key: "listLanguagesResponse",
    value: function listLanguagesResponse(data) {
      return {
        items: this.languageMapper.mapMultipleLanguages(data),
        pagination: this.mapPagination(data.pagination)
      };
    }
    /**
     * Gets response for getting a multiple type
     * @param data Response data
     */

  }, {
    key: "listContentTypesResponse",
    value: function listContentTypesResponse(data) {
      return {
        items: this.typeMapper.mapMultipleTypes(data),
        pagination: this.mapPagination(data.pagination)
      };
    }
    /**
     * Gets response for single type
     * @param data Response data
     * @param options Options
     */

  }, {
    key: "viewContentTypeResponse",
    value: function viewContentTypeResponse(data) {
      return {
        type: this.typeMapper.mapSingleType(data)
      };
    }
  }, {
    key: "itemsFeedResponse",
    value: function itemsFeedResponse(data) {
      var itemsResult = this.itemMapper.mapItems({
        linkedItems: Object.values(data.modular_content),
        mainItems: data.items
      });
      return {
        items: itemsResult.items,
        linkedItems: itemsResult.linkedItems
      };
    }
    /**
     * Gets response for getting single item
     * @param data Response data
     * @param queryConfig Query configuration
     */

  }, {
    key: "viewContentItemResponse",
    value: function viewContentItemResponse(data) {
      var itemResult = this.itemMapper.mapSingleItemFromResponse(data);
      return {
        item: itemResult.item,
        linkedItems: itemResult.linkedItems
      };
    }
    /**
     * Gets response for getting multiple items
     * @param data Response data
     * @param queryConfig Query configuration
     */

  }, {
    key: "listContentItemsResponse",
    value: function listContentItemsResponse(data) {
      var itemsResult = this.itemMapper.mapMultipleItemsFromResponse(data);
      return {
        items: itemsResult.items,
        pagination: this.mapPagination(data.pagination),
        linkedItems: itemsResult.linkedItems
      };
    }
    /**
     * Gets response for getting single taxonomy item
     * @param data Response data
     */

  }, {
    key: "viewTaxonomyResponse",
    value: function viewTaxonomyResponse(data) {
      return {
        taxonomy: this.taxonomyMapper.mapTaxonomy(data.system, data.terms)
      };
    }
    /**
     * Gets response for getting multiples taxonomies
     * @param data Response data
     */

  }, {
    key: "listTaxonomiesResponse",
    value: function listTaxonomiesResponse(data) {
      return {
        items: this.taxonomyMapper.mapTaxonomies(data.taxonomies),
        pagination: this.mapPagination(data.pagination)
      };
    }
    /**
     * Gets response for getting single content type element
     * @param data Response data
     */

  }, {
    key: "viewContentTypeElementResponse",
    value: function viewContentTypeElementResponse(data) {
      return {
        element: this.genericElementMapper.mapElement(data)
      };
    }
  }, {
    key: "initializeContentSync",
    value: function initializeContentSync(data) {
      var _this = this;

      return {
        items: data.items.map(function (m) {
          return _this.syncMapper.mapContentItemDelta(m);
        })
      };
    }
  }, {
    key: "syncChanges",
    value: function syncChanges(data) {
      var _this2 = this;

      return {
        items: data.items.map(function (m) {
          return _this2.syncMapper.mapContentItemDelta(m);
        })
      };
    }
  }, {
    key: "mapPagination",
    value: function mapPagination(paginationContract) {
      var _a;

      return {
        skip: paginationContract.skip,
        count: paginationContract.count,
        limit: paginationContract.limit,
        nextPage: paginationContract.next_page,
        totalCount: (_a = paginationContract.total_count) !== null && _a !== void 0 ? _a : null
      };
    }
  }]);

  return MappingService;
}();